import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";

const Orders = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const location = useLocation();
  const props = location.state;
  const [orders, setOrders] = useState([] as any);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [subTotalTotal, setSubTotalTotal] = useState(0);

  useEffect(() => {
    const orders = JSON.parse(localStorage.getItem("orders") as string);
    let totalQ = 0;
    let totalP = 0;
    let subTotal = 0;
    orders?.forEach((order: any) => {
      totalQ += order.quantity;
      totalP += order.price;
      subTotal += order.price * order.quantity;
    });
    setSubTotalTotal(subTotal);
    setTotalPrice(totalP);
    setTotalQuantity(totalQ);
    setOrders(orders);
  }, []);

  return (
    <div>
      <header>
        <nav
          className="flex justify-between p-2"
          style={{ backgroundColor: colors.blueAccent[300] }}
        >
          <div>
            <Link to={props?.home}>Home</Link>
          </div>
          <div>
            <Link to={"/cart"}>Cart</Link>
          </div>
        </nav>
      </header>
      <div className="ml-5">
        <Header title="Orders" subtitle="Order status" />
      </div>
      <div className="ml-5">
        <table>
          <thead>
            <th className="p-5 border border-black text-start">Id</th>
            <th className="p-5 border border-black text-start">Title</th>
            <th className="p-5 border border-black text-start">Quantity</th>
            <th className="p-5 border border-black text-start">Price</th>
            <th className="p-5 border border-black text-start">Sub Total</th>
          </thead>
          <tbody>
            {orders?.map((order: any) => {
              return (
                <tr className="border border-black" key={order._id}>
                  <td className="p-5 border border-black">{order._id}</td>
                  <td className="p-5 border border-black">{order.title}</td>
                  <td className="p-5 border border-black">{order.quantity}</td>
                  <td className="p-5 border border-black">{order.price}</td>
                  <td className="p-5 border border-black">
                    {order.price * order.quantity}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={2} className="p-5 border border-black text-start">
                Total:{" "}
              </th>
              <td className="p-5 border border-black text-start">
                {totalQuantity}
              </td>
              <td className="p-5 border border-black text-start">
                {totalPrice}
              </td>
              <td className="p-5 border border-black text-start">
                {subTotalTotal}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default Orders;
